'use client';

import Image from 'next/image';
import DesktopStaticBackground from '@/app/assets/animations/desktop-static.png';
import MobileStaticBackground from '@/app/assets/animations/mobile-static.png';

export const AnimatedBackground = () => {
  return (
    <>
      {/* Static images - shown when prefers-reduced-motion is enabled */}
      {/* Mobile static - hidden on sm and above */}
      <Image
        src={MobileStaticBackground}
        alt="static background"
        fill
        className="object-cover css-static-bg css-static-bg-mobile"
        loading="eager"
        data-testid="static-background-mobile"
      />
      {/* Desktop static - hidden below sm */}
      <Image
        src={DesktopStaticBackground}
        alt="static background"
        fill
        className="object-cover css-static-bg css-static-bg-desktop"
        loading="eager"
        data-testid="static-background-desktop"
      />
      {/* CSS Animation - hidden when prefers-reduced-motion is enabled */}
      <div className="css-animation-bg" data-testid="css-animated-background" />
    </>
  );
};
